import { Bits } from '@wemogy/reactbase';
import { types } from 'mobx-state-tree';
import ResourceSubjectPermissionCollection from './ResourceSubjectPermissionCollection';
import Role from './Role';
var PermissionCache = types
    .model({
    tenantId: types.identifier,
    subjectId: types.string,
    resourceSubjectPermissionCollections: types.array(ResourceSubjectPermissionCollection),
    debugRole: types.maybe(types.reference(Role))
})
    .named('PermissionCache')
    .views(function (self) { return ({
    getResourceSubjectPermission: function (levelIndex, pathIndex, resourceId) {
        var resourceSubjectPermissionCollection = self.resourceSubjectPermissionCollections.find(function (x) { return x.levelIndex === levelIndex && pathIndex === pathIndex; });
        if (!resourceSubjectPermissionCollection) {
            return undefined;
        }
        return resourceSubjectPermissionCollection.getResourceSubjectPermission(resourceId);
    },
    hasPermission: function (pathIndex, levelIndex, resourceId, permission, subLevelIndex) {
        var levelRole = this.getPermissions(pathIndex, levelIndex, resourceId, subLevelIndex);
        if (levelRole == undefined) {
            console.error('level role undefined', pathIndex, levelIndex, resourceId, permission, self.resourceSubjectPermissionCollections);
        }
        return levelRole.hasFlag(permission);
    },
    getPermissions: function (pathIndex, levelIndex, resourceId, subLevelIndex) {
        // if a debug role is active => use this role for all resources
        if (self.debugRole) {
            return self.debugRole.getLevelRole(pathIndex, levelIndex + subLevelIndex);
        }
        // try to get the resource subject permission
        var resourceSubjectPermission = this.getResourceSubjectPermission(levelIndex, pathIndex, resourceId);
        if (!resourceSubjectPermission) {
            return new Bits();
        }
        // return the resolved permissions
        return resourceSubjectPermission.permissions[subLevelIndex];
    }
}); })
    .actions(function (self) { return ({
    setDebugRole: function (debugRole) {
        self.debugRole = debugRole;
    },
    removeDebugRole: function () {
        self.debugRole = undefined;
    },
    resourceCreated: function (pathIndex, levelIndex, resourceId, permissions) {
        var _a;
        (_a = self.resourceSubjectPermissionCollections.find(function (x) { return x.pathIndex === pathIndex && x.levelIndex === levelIndex; })) === null || _a === void 0 ? void 0 : _a.addResourceSubjectPermission(resourceId, permissions);
    }
}); });
export default PermissionCache;
//# sourceMappingURL=PermissionCache.js.map